import type { TData } from "../types";

export const findLastFilledColumn = (data: TData): number => {
  let index = -1;
  for (let rowIndex = data.length - 1; rowIndex >= 0; rowIndex--) {
    const row = data[rowIndex];
    let rowLastIndex = -1;

    for (let columnIndex = row.length - 1; columnIndex >= 0; columnIndex--) {
      if (row[columnIndex]?.value) {
        rowLastIndex = columnIndex;
        break;
      }
    }

    if (rowLastIndex > index) index = rowLastIndex;
  }
  return index;
};
